import { AutocompleteRenderGroupParams, autocompleteClasses } from '@mui/material/Autocomplete'
import { Box } from '@mui/system'
import { List, ListItem, Typography } from '@mui/material'

// The fontsize on the h3 variant is set because the current theme & system set Heading variants are still not correct.
// This prop can be removed once the correct heading sizes are applied.
export function TopSearchGroupHeader(params: AutocompleteRenderGroupParams) {
  return (
    <ListItem {...params} sx={{ flexDirection: 'column', alignItems: 'flex-start', m: 0, mb: 3, p: 0, '&:last-child': { mb: 0 } }}>
      {params.group && (
        <Box sx={{ display: 'flex', alignItems: 'center', px: 2, pb: 0.5, width: '100%', boxSizing: 'border-box' }}>
          <Typography variant='h3' sx={{ fontSize: '20px !important', fontWeight: 500, color: '#333' }}>
            {params.group}
          </Typography>
        </Box>
      )}
      <List
        sx={theme => ({
          width: '100%',
          p: 0,
          color: '#333',
          [`& > .${autocompleteClasses.option}`]: {
            minheight: 'auto',
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            px: theme.spacing(2),
            py: theme.spacing(0.5),
            boxSizing: 'border-box',
            outline: 0
          }
        })}
      >
        {params.children}
      </List>
    </ListItem>
  )
}
